import React from 'react';
import { ActivityGroups } from '../components';

export default () => {
    return (
        <ActivityGroups.Home />
    )
}